import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

function MasterAdminLogin() {
  const navigate = useNavigate();
  const { adoptRemoteTheme } = useTheme();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/master-admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Login failed');
      }

      localStorage.setItem('masterAdminToken', data.token);
      localStorage.setItem('masterAdminUser', JSON.stringify(data.user));

      // Sign-in is the only moment this operator's stored theme can be adopted,
      // because nothing in the master admin app calls /master-admin/me. Without
      // this, a theme chosen on one machine would never follow them to another.
      if (data.user?.themePreference) {
        adoptRemoteTheme(data.user.themePreference);
      }

      navigate('/master-admin/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="master-admin-login-page">
      <div className="master-admin-login-box">
        {/* Admin Badge */}
        <div className="master-admin-badge">
          🛡️ PLATFORM ADMIN
        </div>

        <h2 className="master-admin-login-title">
          DeedStack Platform
        </h2>

        <p className="master-admin-login-subtitle">
          Master Admin Portal
        </p>

        {error && (
          <div className="master-admin-login-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="master-admin-form-group">
            <label className="master-admin-form-label">
              Email
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="master-admin-form-input"
              autoComplete="email"
              disabled={loading}
            />
          </div>

          <div className="master-admin-form-group">
            <label className="master-admin-form-label">
              Password
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              className="master-admin-form-input"
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="master-admin-login-submit"
          >
            {loading ? 'Signing in...' : 'Access Platform Admin'}
          </button>
        </form>

        <div className="master-admin-login-footer">
          <p>Platform Administration Only</p>
        </div>
      </div>
    </div>
  );
}

export default MasterAdminLogin;
